import { useMerchant } from '@/src/context/merchant/merchant-context'
import Script from 'next/script'
import React from 'react'

export default function Gtm() {
    const { merchantSummary } = useMerchant()
    const config = merchantSummary?.integrationsConfiguration

    return (
        <>
            {
                config?.googleSiteVerification &&
                <meta name="google-site-verification" content={config.googleSiteVerification} />
            }
            <noscript>
                <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TCKXPRD"
                    style={{ display: "none", visibility: "hidden", height: "0", width: "0" }}>
                </iframe>
            </noscript>
            <Script
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
                                (function (w, d, s, l, i) {
                                w[l] = w[l] || []; w[l].push({
                                    'gtm.start':
                                new Date().getTime(), event: 'gtm.js'
                                }); var f = d.getElementsByTagName(s)[0],
                                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                                'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
                            })(window, document, 'script', 'dataLayer', 'GTM-TCKXPRD');
                        `
                }}
            />

            {
                config?.googleTagManagerId &&
                <>
                    <noscript>
                        <iframe src={`https://www.googletagmanager.com/ns.html?id=${config.googleTagManagerId}`}
                            style={{ display: "none", visibility: "hidden", height: "0", width: "0" }}></iframe>
                    </noscript>
                    <Script
                        strategy="afterInteractive"
                        dangerouslySetInnerHTML={{
                            __html: `
                                    (function (w, d, s, l, i) {
                                w[l] = w[l] || []; w[l].push({
                                    'gtm.start':
                                        new Date().getTime(), event: 'gtm.js'
                                }); var f = d.getElementsByTagName(s)[0],
                                    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                                        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
                                })(window, document, 'script', 'dataLayer', '${config.googleTagManagerId}');
                            `
                        }}
                    />
                </>
            }

            {
                config?.googleAnalyticsId &&
                <>
                    <Script src={`https://www.googletagmanager.com/gtag/js?id=${config?.googleAnalyticsId.replaceAll('\n', '')}`} rel="preconnect" />
                    <Script
                        strategy="afterInteractive"
                        dangerouslySetInnerHTML={{
                            __html: `
                                    window.dataLayer = window.dataLayer || [];
                                    function gtag() { dataLayer.push(arguments); }
                                    gtag('js', new Date());
                                    gtag('config', '${config?.googleAnalyticsId.replaceAll('\n', '')}');
                                `
                        }}
                    />
                </>
            }
        </>
    )
}
